const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';
const SHADDA = '\u0651';
const HARAKAT_RE = /[\u064B-\u065F]/g;

const stripHarakat = s => (s || '').replace(HARAKAT_RE, '');

function getRootLetters(row) {
  const root = stripHarakat((row['שורש'] || row['root'] || '').trim());
  const letters = root.replace(/[^\u0621-\u064A]/g, '');
  if (letters.length !== 3) return null;
  return [letters[0], letters[1], letters[2]];
}

export function conjugatePresentFormIII_Salim(row) {
  const R = getRootLetters(row);
  if (!R) return null;

  const [R1, R2, R3] = R;
  const isNunEnding = R3 === 'ن';

  const stem = R1 + FATHA + 'ا' + R2 + KASRA + R3;

  return {
    'أَنَا'    : 'أ' + DAMMA + stem + DAMMA,
    'أَنْتَ'   : 'ت' + DAMMA + stem + DAMMA,
    'أَنْتِ'   : 'ت' + DAMMA + stem + KASRA + 'ينَ',
    'هُوَ'     : 'ي' + DAMMA + stem + DAMMA,
    'هِيَ'     : 'ت' + DAMMA + stem + DAMMA,
    'نَحْنُ'   : 'ن' + DAMMA + stem + DAMMA,
    'أَنْتُمْ' : 'ت' + DAMMA + stem + DAMMA + 'ونَ',
    'أَنْتُنَّ': isNunEnding ? 'ت' + DAMMA + stem + SHADDA + FATHA : 'ت' + DAMMA + stem + SUKUN + 'نَ',
    'هُمْ'     : 'ي' + DAMMA + stem + DAMMA + 'ونَ',
    'هُنَّ'    : isNunEnding ? 'ي' + DAMMA + stem + SHADDA + FATHA : 'ي' + DAMMA + stem + SUKUN + 'نَ',
  };
}

export function conjugatePresentFormIII_Salim_fromRow(row) {
  const binyan = (row['בניין'] || '').trim();
  const gizra = (row['gizra'] || '').trim();

  if (!(binyan === '3' || binyan === 'בניין 3')) return null;
  const gizraOk = gizra.includes('שלמים') || gizra.includes('ע"ו') || gizra.includes('פ"ו');
  if (!gizraOk) return null;

  return conjugatePresentFormIII_Salim(row);
}
